import { render, staticRenderFns } from "./CollegeSpecialtyAssess.vue?vue&type=template&id=4f49166d&scoped=true"
import script from "./CollegeSpecialtyAssess.vue?vue&type=script&lang=js"
export * from "./CollegeSpecialtyAssess.vue?vue&type=script&lang=js"
import style0 from "./CollegeSpecialtyAssess.vue?vue&type=style&index=0&id=4f49166d&prod&scoped=true&lang=less"
import style1 from "./CollegeSpecialtyAssess.vue?vue&type=style&index=1&id=4f49166d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49166d",
  null
  
)

export default component.exports